import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './cityBrowseHeaderImage.scss';

import { getRandomAsset } from '../../utils';
import { splitCityName } from './utils';
import { CITY_GRADIENTS } from '../../../../constants';

const CityImage = ({
    cityImage,
    citySmallImage,
    currentPlace,
    imgClassNames,
}) => {
    let component = null;

    if (cityImage && citySmallImage) {
        component = (
            <img
                srcSet={`
                    ${citySmallImage} 512w,
                    ${cityImage} 1400w
                `}
                sizes="
                    (max-width: 512px) 100vw,
                    1400px
                "
                src={cityImage}
                alt={currentPlace}
                className={imgClassNames}
            />
        );
    } else if (cityImage) {
        component = (
            <img src={cityImage} alt={currentPlace} className={imgClassNames} />
        );
    }

    return component;
};

const HeaderImage = ({
    currentPlace,
    cityImage,
    citySmallImage,
    shouldHideMask,
}) => {
    const imgClassNames = classNames('full-width-img', {
        'city-browse-header__fallback-image': !shouldHideMask,
    });

    let component = (
        <CityImage
            cityImage={cityImage}
            citySmallImage={citySmallImage}
            currentPlace={currentPlace}
            imgClassNames={imgClassNames}
        />
    );

    if (!shouldHideMask) {
        const { firstCityName, secondCityName } = splitCityName(currentPlace);

        const fallbackContainerClassName = classNames(
            'city-browse-header__fallback_container',
            {
                [`${getRandomAsset(CITY_GRADIENTS, currentPlace)}`]: !cityImage,
            },
        );

        component = (
            <div className={fallbackContainerClassName}>
                {component}
                <div className="eds-text-weight--light city-browse-header__fallback-text city-browse-header__fallback-text-1">
                    {firstCityName}
                </div>
                <div className="eds-text-weight--light city-browse-header__fallback-text city-browse-header__fallback-text-2">
                    {secondCityName}
                </div>
                <img
                    src="/static/images/search/fall-back-mask.png"
                    alt=""
                    className="city-browse-header__fallback-image-mask"
                />
            </div>
        );
    }

    return component;
};

export class CityBrowseHeaderImage extends React.PureComponent {
    static propTypes = {
        currentPlace: PropTypes.string,
        cityImage: PropTypes.string,
        citySmallImage: PropTypes.string,
        shouldHideMask: PropTypes.bool,
    };

    render() {
        const {
            currentPlace,
            cityImage,
            citySmallImage,
            shouldHideMask,
            experiments,
        } = this.props;

        return (
            <HeaderImage
                currentPlace={currentPlace}
                cityImage={cityImage}
                citySmallImage={citySmallImage}
                shouldHideMask={shouldHideMask}
                experiments={experiments}
            />
        );
    }
}
